import axios from "axios";
import { CF_BASE_URL } from "../../constants";

const config = {
  baseURL: CF_BASE_URL,
};

const cloudRunConfig = {
  baseURL: process.env.NEXT_PUBLIC_CLOUD_RUN_BASE_URL,
};
export const instance = axios.create(config);

export const authorisedInstance = axios.create(config);

export const cloudRunInstance = axios.create(cloudRunConfig);


authorisedInstance.interceptors.request.use(
  function (config) {
    config.headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

cloudRunInstance.interceptors.request.use(
  function (config) {
    config.headers = {
      Authorization: "Bearer " + process.env.NEXT_PUBLIC_AUTH_TOKEN,
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
